// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal[data-v-be86e5e0]{padding:24px}.modal-buttons-item[data-v-be86e5e0],.modal-title[data-v-be86e5e0]{margin-bottom:16px}.modal-buttons-item[data-v-be86e5e0]:last-child{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
